import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import OtherRenewableEnergyDetail from '../../components/renewable_energy/OtherRenewableEnergyDetail';
import { editOtherRenewableEnergy } from '../../redux/renewable_energy/other_renewable_energy_actions';
import { defaultRejectHandler } from '../../utils/utility';

class OtherRenewableEnergyEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.renewableEnergyDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newRenewableEnergy = this.renewableEnergyDetail.getWrappedInstance().getRenewableEnergyData();
    this.props.editOtherRenewableEnergy({ ...newRenewableEnergy, id: this.props.renewableEnergy.id });
  }

  render() {
    const { isEditing, errorMessage, renewableEnergy, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit other renewable energy')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OtherRenewableEnergyDetail
            renewableEnergy={renewableEnergy}
            ref={ref => (this.renewableEnergyDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="other-renewable-energy-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const renewableEnergyState = state.renewableEnergy.otherEnergy;
  return {
    errorMessage: renewableEnergyState.errorMessage,
    isEditing: renewableEnergyState.isEditing,
  };
};

const mapDispatchToProps = dispatch => ({
  editOtherRenewableEnergy: renewableEnergy =>
    defaultRejectHandler(
      dispatch(
        editOtherRenewableEnergy(
          renewableEnergy.id,
          renewableEnergy.name,
          renewableEnergy.energy,
          renewableEnergy.description,
          renewableEnergy.image,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OtherRenewableEnergyEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/renewable_energy/OtherRenewableEnergyEditModal.js